import React from "react";
import { Card, CardBody, Col, Container, Row } from "reactstrap";

import TicketForm from "./TicketForm";

const CardAssign: React.FC = () => {
  return (
    <div className="page-body">
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <div className="container mt-4">
                  <div className="row gy-4">
                    {/* Product Grid Column */}
                      <TicketForm />
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default CardAssign;
